import { render, staticRenderFns } from "./AddUniLevelBonus.vue?vue&type=template&id=613b4797&"
import script from "./AddUniLevelBonus.vue?vue&type=script&lang=js&"
export * from "./AddUniLevelBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports